import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import usePageMeta from "@/hooks/usePageMeta";
import { articles } from "@/mocks/articles";

const tabs = [
  { label: "全部", value: "all" },
  { label: "追更指南", value: "guide" },
  { label: "精选推荐", value: "recommend" },
  { label: "使用技巧", value: "tips" },
  { label: "行业观察", value: "insight" },
];

export default function ArticlesPage() {
  usePageMeta("追更指南与精选推荐 - 正版韩漫大全", "正版韩漫大全追更指南、精选推荐与版权科普合集，帮你快速上手正版韩漫，避开盗版站。");
  const [active, setActive] = useState("all");

  const list = useMemo(
    () => (active === "all" ? articles : articles.filter((a) => a.categorySlug === active)),
    [active]
  );

  return (
    <div className="bg-background-50">
      <div className="bg-primary-50/50">
        <div className="mx-auto w-full max-w-7xl px-4 py-10 md:px-6 md:py-14">
          <nav className="text-xs text-foreground-500" aria-label="面包屑">
            <ol className="flex items-center gap-1.5">
              <li><Link to="/" className="hover:text-primary-600">首页</Link></li>
              <li><i className="ri-arrow-right-s-line"></i></li>
              <li className="text-foreground-800" aria-current="page">追更指南</li>
            </ol>
          </nav>
          <h1 className="mt-4 font-heading text-2xl font-bold text-foreground-900 md:text-3xl">追更指南与精选推荐</h1>
          <p className="mt-2 max-w-2xl text-sm text-foreground-600">
            从选漫到追更，从版权科普到使用技巧，正版韩漫大全的精选内容都整理在这里。
          </p>
        </div>
      </div>

      <div className="mx-auto w-full max-w-7xl px-4 py-10 md:px-6 md:py-14">
        <div className="flex flex-wrap gap-2" role="tablist" aria-label="文章分类">
          {tabs.map((t) => (
            <button
              key={t.value}
              type="button"
              role="tab"
              aria-selected={active === t.value}
              onClick={() => setActive(t.value)}
              className={`whitespace-nowrap rounded-full px-4 py-2 text-sm transition-colors ${
                active === t.value
                  ? "bg-primary-500 text-background-50"
                  : "bg-background-100 text-foreground-600 hover:bg-background-200"
              }`}
            >
              {t.label}
            </button>
          ))}
        </div>

        <div className="mt-8 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
          {list.map((a) => (
            <Link
              key={a.id}
              to={`/article/${a.slug}`}
              className="group overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all hover:-translate-y-1 hover:border-primary-300"
            >
              <div className="relative overflow-hidden">
                <img
                  src={a.cover}
                  alt={`${a.title}封面`}
                  className="aspect-[3/2] w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-full bg-primary-500 px-2.5 py-1 text-xs font-medium text-background-50">
                  {a.tag}
                </span>
              </div>
              <div className="p-5">
                <div className="flex items-center gap-2 text-xs text-foreground-500">
                  <span className="text-primary-600">{a.category}</span>
                  <span>·</span>
                  <span>{a.date}</span>
                </div>
                <h2 className="mt-3 font-heading text-base font-bold leading-snug text-foreground-900 group-hover:text-primary-600">
                  {a.title}
                </h2>
                <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">{a.summary}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}